import React, { useEffect, useState } from "react";
import Pagination from "../../components/Pagination";
import { Link } from "react-router-dom";
import { formatToDate } from "../../master/FormatToDateTime";
import { EnquiryStatusBadge, getFollowupsList } from "./Master";
import usePrivateLink from "../../config/usePrivateLink";
import FollowUpModal from "./FollowUpModal";
import { LoadingDiv } from "../../master/Master";
import StatusModal from "./StatusModal";

export default function EnquiryFollowupTable({ filters, setFilters }) {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [modalData, setModalData] = useState({});

  const handleFunction = () => {
    getFollowupsList({
      setLoading,
      filters,
      setData,
    });
  };

  useEffect(() => {
    handleFunction();
  }, [filters]);
  return (
    <>
      {loading && <LoadingDiv />}

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: 36,
              height: 36,
              borderRadius: "10px",
              background: "#eef4ff",
            }}
          >
            <i className="ri-phone-line text-primary"></i>
          </div>

          <div>
            <small className="text-muted">Total Followups</small>
            <h6 className="m-0 fw-bold text-primary">{data?.total || 0}</h6>
          </div>
        </div>

        <div style={{ width: "320px", maxWidth: "100%" }}>
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Name, Mobile"
              value={filters?.search || ""}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  search: e.target.value.toUpperCase(),
                })
              }
            />
            <label>
              <i className="ri-search-line me-1"></i>
              Search
            </label>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead
            className="text-nowrap"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              background: "#fff",
            }}
          >
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Father's Name</th>
              <th>Mobile</th>
              <th>Course</th>
              <th>Enquiry Date</th>
              <th>Counselor</th>
              <th>Last Follow Up</th>
              <th>Response</th>
              <th>Next Follow Up</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="text-capitalize">
            {data?.data?.map((item, i) => (
              <tr key={item.id}>
                <td>{i + 1}</td>
                <td style={{ minWidth: "220px" }}>
                  <Link
                    to={`/enquiry/detail?id=${item?.enquiry?.id}`}
                    className="fw-semibold text-primary text-decoration-none"
                  >
                    {item?.enquiry?.student_name}

                    {item?.enquiry?.enquiry_no && (
                      <small className="text-muted ms-1">
                        ({item?.enquiry?.enquiry_no})
                      </small>
                    )}
                  </Link>
                </td>
                <td>{item?.enquiry?.father_name}</td>
                <td>{item?.enquiry?.mobile}</td>
                <td>{item?.enquiry?.course?.title}</td>
                <td>{formatToDate(item?.enquiry?.enquiry_date)}</td>
                <td style={{ minWidth: "180px" }}>
                  <div>{item?.counselor?.name}</div>

                  <small className="text-muted">
                    {item?.counselor?.registration_no}
                  </small>
                </td>
                <td>{formatToDate(item?.followup_date)}</td>
                <td
                  style={{
                    maxWidth: "250px",
                    whiteSpace: "normal",
                  }}
                >
                  {item?.response || "-"}
                </td>
                <td>{formatToDate(item?.next_followup_date)}</td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => setModalData(item?.enquiry)}
                >
                  {EnquiryStatusBadge(item?.enquiry?.status)}
                </td>

                <td>
                  <div className="d-flex gap-2">
                    {hasAccess("/enquiry/detail") && (
                      <Link to={`/enquiry/detail?id=${item?.enquiry?.id}`}>
                        <i className="ri-eye-line text-primary ri-lg"></i>
                      </Link>
                    )}

                    {hasAccess("/enquiry/followups/add") && (
                      <i
                        className="ri-phone-line text-success cursor-pointer ri-lg"
                        data-bs-toggle="modal"
                        data-bs-target="#AddNewFollowup"
                        onClick={() => setModalData(item?.enquiry)}
                      ></i>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {data?.data?.length === 0 && (
              <tr>
                <td colSpan="12" className="text-center py-5">
                  <i className="ri-phone-find-line fs-1 text-muted"></i>

                  <div className="mt-2 text-muted">No followups found</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Pagination data={data} setFilters={setFilters} filters={filters} />

        <FollowUpModal
          data={modalData}
          setLoading={setLoading}
          handleFunction={handleFunction}
        />
        <StatusModal
          data={modalData}
          setData={setModalData}
          setLoading={setLoading}
          handleFunction={handleFunction}
        />
      </div>
    </>
  );
}
